const interdemilao = [
  {
    id: 1,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2025",
      "2025 inter de milao",
      "2025",
      "internacionale 2025",
      "2025 internacionale",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/interdemilao/25-26-01/uni0.jpg",
      "/images/europa/interdemilao/25-26-01/uni1.jpg",
      "/images/europa/interdemilao/25-26-01/uni2.jpg",
      "/images/europa/interdemilao/25-26-01/uni3.jpg",
      "/images/europa/interdemilao/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2025",
      "2025 inter de milao",
      "2025",
      "internacionale 2025",
      "2025 internacionale",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/interdemilao/25-26-02/uni0.jpg",
      "/images/europa/interdemilao/25-26-02/uni1.jpg",
      "/images/europa/interdemilao/25-26-02/uni2.jpg",
      "/images/europa/interdemilao/25-26-02/uni3.jpg",
      "/images/europa/interdemilao/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2024",
      "2024 inter de milao",
      "2024",
      "internacionale 2024",
      "2024 internacionale",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/interdemilao/24-25-01/uni0.jpg",
      "/images/europa/interdemilao/24-25-01/uni1.jpg",
      "/images/europa/interdemilao/24-25-01/uni2.jpg",
      "/images/europa/interdemilao/24-25-01/uni3.jpg",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2024",
      "2024 inter de milao",
      "2024",
      "internacionale 2024",
      "2024 internacionale",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/interdemilao/24-25-02/uni0.jpg",
      "/images/europa/interdemilao/24-25-02/uni1.jpg",
      "/images/europa/interdemilao/24-25-02/uni2.jpg",
      "/images/europa/interdemilao/24-25-02/uni3.jpg",
      "/images/europa/interdemilao/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2024",
      "2024 inter de milao",
      "2024",
      "internacionale 2024",
      "2024 internacionale",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/interdemilao/24-25-03/uni0.jpg",
      "/images/europa/interdemilao/24-25-03/uni1.jpg",
      "/images/europa/interdemilao/24-25-03/uni2.jpg",
      "/images/europa/interdemilao/24-25-03/uni3.jpg",
      "/images/europa/interdemilao/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 23/24 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2023",
      "2023 inter de milao",
      "2023",
      "internacionale 2023",
      "2023 internacionale",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/interdemilao/23-24-01/uni0.jpg",
      "/images/europa/interdemilao/23-24-01/uni1.jpg",
      "/images/europa/interdemilao/23-24-01/uni2.jpg",
      "/images/europa/interdemilao/23-24-01/uni3.jpg",
      "/images/europa/interdemilao/23-24-01/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2021",
      "2021 inter de milao",
      "2021",
      "internacionale 2021",
      "2021 internacionale",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/interdemilao/21-22-01/uni0.jpg",
      "/images/europa/interdemilao/21-22-01/uni1.jpg",
      "/images/europa/interdemilao/21-22-01/uni2.jpg",
      "/images/europa/interdemilao/21-22-01/uni3.jpg",
      "/images/europa/interdemilao/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 21/22 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2021",
      "2021 inter de milao",
      "2021",
      "internacionale 2021",
      "2021 internacionale",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/interdemilao/21-22-02/uni0.jpg",
      "/images/europa/interdemilao/21-22-02/uni1.jpg",
      "/images/europa/interdemilao/21-22-02/uni2.jpg",
      "/images/europa/interdemilao/21-22-02/uni3.jpg",
      "/images/europa/interdemilao/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 19/20 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2019",
      "2019 inter de milao",
      "2019",
      "internacionale 2019",
      "2019 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/19-20-02-rt/uni0.jpg",
      "/images/europa/interdemilao/19-20-02-rt/uni1.jpg",
      "/images/europa/interdemilao/19-20-02-rt/uni2.jpg",
      "/images/europa/interdemilao/19-20-02-rt/uni3.jpg",
      "/images/europa/interdemilao/19-20-02-rt/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 19/20 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2019",
      "2019 inter de milao",
      "2019",
      "internacionale 2019",
      "2019 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/19-20-03-rt/uni0.jpg",
      "/images/europa/interdemilao/19-20-03-rt/uni1.jpg",
      "/images/europa/interdemilao/19-20-03-rt/uni2.jpg",
      "/images/europa/interdemilao/19-20-03-rt/uni3.jpg",
      "/images/europa/interdemilao/19-20-03-rt/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 09/10 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2009",
      "2009 inter de milao",
      "2009",
      "internacionale 2009",
      "2009 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/09-10-01-rt/uni0.jpg",
      "/images/europa/interdemilao/09-10-01-rt/uni1.jpg",
      "/images/europa/interdemilao/09-10-01-rt/uni2.jpg",
      "/images/europa/interdemilao/09-10-01-rt/uni3.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 09/10 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2009",
      "2009 inter de milao",
      "2009",
      "internacionale 2009",
      "2009 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/09-10-02-rt/uni0.jpg",
      "/images/europa/interdemilao/09-10-02-rt/uni1.jpg",
      "/images/europa/interdemilao/09-10-02-rt/uni2.jpg",
      "/images/europa/interdemilao/09-10-02-rt/uni3.jpg",
      "/images/europa/interdemilao/09-10-02-rt/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 04/05 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2004",
      "2004 inter de milao",
      "2004",
      "internacionale 2004",
      "2004 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/04-05-01-rt/uni0.jpg",
      "/images/europa/interdemilao/04-05-01-rt/uni1.jpg",
      "/images/europa/interdemilao/04-05-01-rt/uni2.jpg",
      "/images/europa/interdemilao/04-05-01-rt/uni3.jpg",
      "/images/europa/interdemilao/04-05-01-rt/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 04/05 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2004",
      "2004 inter de milao",
      "2004",
      "internacionale 2004",
      "2004 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/04-05-02-rt/uni0.jpg",
      "/images/europa/interdemilao/04-05-02-rt/uni1.jpg",
      "/images/europa/interdemilao/04-05-02-rt/uni2.jpg",
      "/images/europa/interdemilao/04-05-02-rt/uni3.jpg",
      "/images/europa/interdemilao/04-05-02-rt/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 04/05 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2004",
      "2004 inter de milao",
      "2004",
      "internacionale 2004",
      "2004 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/04-05-03-rt/uni0.jpg",
      "/images/europa/interdemilao/04-05-03-rt/uni1.jpg",
      "/images/europa/interdemilao/04-05-03-rt/uni2.jpg",
      "/images/europa/interdemilao/04-05-03-rt/uni3.jpg",
      "/images/europa/interdemilao/04-05-03-rt/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 02/03 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 2002",
      "2002 inter de milao",
      "2002",
      "internacionale 2002",
      "2002 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/02-03-01-rt/uni0.jpg",
      "/images/europa/interdemilao/02-03-01-rt/uni1.jpg",
      "/images/europa/interdemilao/02-03-01-rt/uni2.jpg",
      "/images/europa/interdemilao/02-03-01-rt/uni3.jpg",
      "/images/europa/interdemilao/02-03-01-rt/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 99/00 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 1999",
      "1999 inter de milao",
      "1999",
      "internacionale 1999",
      "1999 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/99-00-01-rt/uni0.jpg",
      "/images/europa/interdemilao/99-00-01-rt/uni1.jpg",
      "/images/europa/interdemilao/99-00-01-rt/uni2.jpg",
      "/images/europa/interdemilao/99-00-01-rt/uni3.jpg",
      "/images/europa/interdemilao/99-00-01-rt/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 98/99 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 1998",
      "1998 inter de milao",
      "1998",
      "internacionale 1998",
      "1998 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/98-99-01-rt/uni0.jpg",
      "/images/europa/interdemilao/98-99-01-rt/uni1.jpg",
      "/images/europa/interdemilao/98-99-01-rt/uni2.jpg",
      "/images/europa/interdemilao/98-99-01-rt/uni3.jpg",
      "/images/europa/interdemilao/98-99-01-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 98/99 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 1998",
      "1998 inter de milao",
      "1998",
      "internacionale 1998",
      "1998 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/98-99-03-rt/uni0.jpg",
      "/images/europa/interdemilao/98-99-03-rt/uni1.jpg",
      "/images/europa/interdemilao/98-99-03-rt/uni2.jpg",
      "/images/europa/interdemilao/98-99-03-rt/uni3.jpg",
      "/images/europa/interdemilao/98-99-03-rt/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 97/98 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 1997",
      "1997 inter de milao",
      "1997",
      "internacionale 1997",
      "1997 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/97-98-02-rt/uni0.jpg",
      "/images/europa/interdemilao/97-98-02-rt/uni1.jpg",
      "/images/europa/interdemilao/97-98-02-rt/uni2.jpg",
      "/images/europa/interdemilao/97-98-02-rt/uni3.jpg",
      "/images/europa/interdemilao/97-98-02-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 94/95 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 1994",
      "1994 inter de milao",
      "1994",
      "internacionale 1994",
      "1994 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/94-95-02-rt/uni0.jpg",
      "/images/europa/interdemilao/94-95-02-rt/uni1.jpg",
      "/images/europa/interdemilao/94-95-02-rt/uni2.jpg",
      "/images/europa/interdemilao/94-95-02-rt/uni3.jpg",
      "/images/europa/interdemilao/94-95-02-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "europa",
    liga: "serie-a",
    time: "inter-de-milao",
    nome: "Inter de Milão 92-93 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "inter de milao",
      "internacionale",
      "inter",
      "inter de milao 1992",
      "1992 inter de milao",
      "1992",
      "internacionale 1992",
      "1992 internacionale",
      "inter de milao retro",
      "retro inter de milao",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/interdemilao/92-93-02-rt/uni0.jpg",
      "/images/europa/interdemilao/92-93-02-rt/uni1.jpg",
      "/images/europa/interdemilao/92-93-02-rt/uni2.jpg",
      "/images/europa/interdemilao/92-93-02-rt/uni3.jpg",
      "/images/europa/interdemilao/92-93-02-rt/uni4.jpg",
    ],
  },
];

export default interdemilao;
